document.addEventListener("DOMContentLoaded", function () {
  document
    .querySelectorAll(".collection-carousel-container")
    .forEach((carouselContainer) => {
      const carousel = carouselContainer.querySelector(
        ".collection-carousel-items"
      );
      const prevBtn = carouselContainer.querySelector(".prev");
      const nextBtn = carouselContainer.querySelector(".next");
      const cardWidth = 240; // Ancho de la tarjeta + margen
      let position = 0;

      if (!carousel || !prevBtn || !nextBtn) return; // Evita errores si faltan elementos

      prevBtn.addEventListener("click", () => {
        if (position < 0) {
          position += cardWidth;
          carousel.style.transform = `translateX(${position}px)`;
        }
      });

      nextBtn.addEventListener("click", () => {
        const maxPosition = -(carousel.scrollWidth - carousel.clientWidth);
        if (position > maxPosition) {
          position -= cardWidth;
          carousel.style.transform = `translateX(${position}px)`;
        }
      });
    });
});
